<template>
	<div class="md-layout">
		<div class="md-layout-item md-medium-size-50 md-size-50">
			<h4>ការគ្រប់គ្រងសារជូនដំណឹង</h4>
		</div>
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<md-card>
				<md-card-content>
					<loading v-if="!loaded" />
					<div v-if="loaded">
						<el-tabs v-model="tabName">
							<el-tab-pane label="តារាងសារជូនដំណឹង" name="first"></el-tab-pane>
							<el-tab-pane label="បង្កើតសារជូនដំណឹងថ្មី" name="second"></el-tab-pane>
						</el-tabs>

						<div v-if="tabName == 'first'">
							<md-table v-if="notification_list.length > 0">
								<md-table-row>
									<md-table-head>ល.រ.</md-table-head>
									<md-table-head>ចំណងជើង</md-table-head>
									<md-table-head>សារជូនដំណឹង</md-table-head>
									<md-table-head>ថ្ងៃបង្កើត</md-table-head>
									<md-table-head>សកម្មភាព</md-table-head>
								</md-table-row>

								<md-table-row v-for="(notification, index) in notification_list">
									<md-table-cell>{{ index + 1}}</md-table-cell>
									<md-table-cell>{{ notification.title }}</md-table-cell>
									<md-table-cell>{{ notification.body }}</md-table-cell>
									<md-table-cell>{{ config.datelify(notification.created_date)[1] }}</md-table-cell>
									<md-table-cell></md-table-cell>
								</md-table-row>
							</md-table>
							<h5 class="text-center" v-if="notification_list.length == 0 && loaded == true">មិនមានសារជូនដំណឹង</h5>
						</div>

						<div v-if="tabName == 'second'">
							<div class="md-layout">
								<div class="md-layout-item md-small-size-100 md-size-100">
									<md-field>
										<label>ចំណងជើង</label>
										<md-input type="text" v-model="notification.title"></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-100">
									<md-field>
										<label>សារជូនដំណឹង</label>
										<md-input type="text" v-model="notification.body"></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-size-100 text-right">
									<md-button class="md-raised md-primary" @click="postDialogActive = true" >ជូនដំណឹង</md-button>
								</div>
							</div>

						</div>
					</div>

						<md-dialog-confirm :md-active.sync="postDialogActive"
						:md-title="'តើអ្នកពិតជាចង់ជូនដំណឹងមែនឬ​ ?'" :md-confirm-text="'យល់ព្រម'"
						:md-cancel-text="'បោះបង់'" @md-cancel="cancel" @md-confirm="post" />
				</md-card-content>
			</md-card>
		</div>
	</div>
</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: {
			datetime: Datetime
		},
		created() {
			this.searchHandler();
		},
		data() {
			return {
				tabName: 'first',
				loaded: false,
				loadMore: false,
				notification_list: [],
				notification: {
					title: "",
					body: ""
				},
				search: {
					text: ""
				},
				postDialogActive: false
			}
		},
		methods: {
			searchHandler(more = false) {
				let size = 50;
				this.$http.post(this.config.api + "/user/notification/search", {
					text: this.search.text,
					size: size,
					offset: more ? this.notification_list.length : 0
				}).then(data => {
					this.loaded = true;
					if (data.body.data.length == size) this.loadMore = true;
					else this.loadMore = false;
					this.notification_list = more ? this.notification_list.concat(data.body.data) : data.body.data;
				})
			},
			cancel() {
				this.postDialogActive = false;
			},

			post() {

				if(String(this.notification.title).length < 3 || String(this.notification.body).length < 3) {
					this.$notification.notify({ message: "សូមបំពេញព័ត៌មានបន្ថែម", icon: 'info', type: 'warning' });
					return false;
				}

				this.$http.post(this.config.api + "/user/notification/post", {
					title: this.notification.title,
					body: this.notification.body,
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({ message: "អ្នកបានផ្ញើសារជូនដំណឹងដោយជោគជ័យ។", icon: 'check_circle', type: 'success' });
						this.searchHandler();
						this.tabName = 'first';
						this.notification.title = "";
						this.notification.body = "";
					}
				});
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/Notifications/View.vue